export class ForbiddenError extends Error {
    readonly name: string = "ForbiddenError";

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
